import React from 'react'
import {accommodationTypeMap} from "../utils/constants";

export default class ImageGridItem extends React.Component{

    getMediumSizedImageUrl = (allImagesOfProperty) => {
        if(allImagesOfProperty.length > 0){
            let originalImageUrl = allImagesOfProperty[0];
            var urlparts = originalImageUrl.split('/');
            var positionToInsert = urlparts.length - 1;
            const items = urlparts;
            const insert = (arr, index, newItem) => [
                // part of the array before the specified index
                ...arr.slice(0, index),
                // inserted item
                newItem,
                // part of the array after the specified index
                ...arr.slice(index)
            ];
            return insert(items, positionToInsert, 'big').join('/');
            }
        else{
            return '';
        }
    };

    render(){
    return(
        <div className="delegate-info-this.props.item">
            <div
                className={`accommodation-card accommodation-card--${this.props.item.wishlisted ? 'highlight' : 'default'}`}
                key={this.props.item.uuid}
            >
                <div className='accommodation-card__gallery'>
                    <div className="carousel" style={{height: 182}}>
                        <div className="card-gallery__image slide" style={{
                            backgroundImage: `url(${this.getMediumSizedImageUrl(this.props.item.images)})`,
                            objectFit: 'cover'
                        }}></div>
                    </div>
                </div>

                <div className='accommodation-card__details'>

                    <h3 className='accommodation-card__title'>
                        <a href={this.props.item.url}>{this.props.item.title}</a>
                    </h3>
                    <h4 className='accommodation-card__subtitle'>
                        {accommodationTypeMap[this.props.item.type]}, {this.props.eventCity} #{this.props.item.reference_number}
                    </h4>

                    <ul className='accommodation-card__features list-inline'>
                        <li className='bedrooms'>{this.props.item.bedrooms}</li>
                        <li className='beds'>{this.props.item.beds}</li>
                        <li className='distance'>{this.props.item.distance}km</li>
                        <li className='price'>{this.props.pricesForBookedAccommodations[this.props.item.reference_number]}€</li>
                    </ul>
                </div>
                <div className="accommodation-card__footer">
                    <a onClick={() => this.openDownloadKeyInstructionsLink(this.props.item.reference_number)}> <label style={{
                        background: '#808184',
                        color: '#fff',
                        display: 'block',
                        padding: '1rem',
                        textAlign: 'right',
                        transition: 'background .2s ease',
                        cursor: 'pointer',
                        position: 'relative'
                    }}>Download Key Instructions</label></a>
                </div>
            </div>
        </div>
    )
    }
}


// WEBPACK FOOTER //
// ./src/components/ImageGridItem.js